import { BaseContainerModel } from '../../base-container.model';
import {bl_fi_mto_option_line_RowClass} from '../../../dbschema';

export class MTOOptionLineContainerModel extends BaseContainerModel {

  bl_fi_mto_option_line: bl_fi_mto_option_line_RowClass = new bl_fi_mto_option_line_RowClass();
}
